<section class="w-full">
  <header class="l-flex l-align-y l-align-spaceBetween">
    <h2 class="t-widgetTitle">
      <span *ngIf="isNew">
        {{ "translate.notes.createTitle" | translate }}
      </span>
      <span *ngIf="!isNew">
        {{ "translate.notes.updTitle" | translate }}
      </span>
    </h2>
    <i class="fas fa-times t-popupCloseIcon" (click)="closePanel()"></i>
  </header>
  <hr />
</section>

<div class="body-container">
  <div class="l-align-spaceBetween">
    <input-wrap
      label="{{ 'translate.notes.heText' | translate }}"
      cssClass="l-cell-spread"
    >
      <textarea
        dir="auto"
        class="t-input t-input--colored"
        [(ngModel)]="note.he"
        rows="10"
        [disabled]="!allowEdit"
      ></textarea>
    </input-wrap>

    <input-wrap
      label="{{ 'translate.notes.enText' | translate }}"
      cssClass="l-cell-spread"
    >
      <textarea
        dir="auto"
        class="t-input t-input--colored"
        [(ngModel)]="note.en"
        rows="10"
        [disabled]="!allowEdit"
      ></textarea>
    </input-wrap>

    <input-wrap
      label="{{ 'translate.notes.cnText' | translate }}"
      cssClass="l-cell-spread"
    >
      <textarea
        dir="auto"
        class="t-input t-input--colored"
        [(ngModel)]="note.cn"
        rows="10"
      ></textarea>
    </input-wrap>
  </div>

  <ng-container *ngIf="allowEdit">
    <div class="l-align-spaceBetween">
      <div class="assign">
        <input-wrap
          label="{{ 'translate.notes.lab' | translate }}"
          [singleLine]="true"
        >
          <checkbox-wrap class="checkbox">
            <input type="checkbox" [(ngModel)]="note.displayLabSw" />
          </checkbox-wrap>
        </input-wrap>

        <input-wrap
          label="{{ 'translate.notes.allDoctorsSw' | translate }}"
          [singleLine]="true"
        >
          <checkbox-wrap class="checkbox">
            <input type="checkbox" [(ngModel)]="note.allDoctorsSw" />
          </checkbox-wrap>
        </input-wrap>

        <input-wrap
          label="{{ 'translate.notes.doctors' | translate }}"
          [loading]="doctors && doctors.loading"
          [singleLine]="true"
          cssClass="long"
        >
          <p-multiSelect
            class="t-input--colored item-select"
            [options]="doctors"
            [(ngModel)]="note.doctors"
            [placeholder]="'translate.general.chooseItem' | translate"
            [optionLabel]="'label'"
            appendTo="body"
            [maxSelectedLabels]="2"
            [selectedItemsLabel]="
              'translate.general.multiselectItemsSelected' | translate
            "
            [virtualScroll]="true"
            [virtualScrollItemSize]="30"
          >
          </p-multiSelect>
        </input-wrap>
      </div>

      <div class="assign">
        <input-wrap
          label="{{ 'translate.notes.allItemsSw' | translate }}"
          [singleLine]="true"
        >
          <checkbox-wrap class="checkbox">
            <input type="checkbox" [(ngModel)]="note.allItemsSw" />
          </checkbox-wrap>
        </input-wrap>

        <input-wrap
          label="{{ 'translate.notes.items' | translate }}"
          [loading]="rxItems && rxItems.loading"
          [singleLine]="true"
          cssClass="long"
        >
          <p-multiSelect
            class="t-input--colored item-select"
            [options]="rxItems"
            [(ngModel)]="note.rxItems"
            [placeholder]="'translate.general.chooseItem' | translate"
            [optionLabel]="'label'"
            appendTo="body"
            [maxSelectedLabels]="2"
            [selectedItemsLabel]="
              'translate.general.multiselectItemsSelected' | translate
            "
          >
          </p-multiSelect>
        </input-wrap>
      </div>
    </div>
  </ng-container>
</div>

<div class="footer">
  <div class="t-buttonSet">
    <button
      *ngIf="allowEdit && !isNew && note.status == 'ACTIVE'"
      [disabled]="saving || !saveEnabled()"
      (click)="deactivate()"
      class="t-button-outline warn"
    >
      {{ "translate.notes.deactivate" | translate }}
    </button>

    <button
      *ngIf="allowEdit && !isNew && note.status != 'ACTIVE'"
      [disabled]="saving || !saveEnabled()"
      (click)="delete()"
      class="t-button-outline warn"
    >
      {{ "translate.notes.delete" | translate }}
    </button>
  </div>

  <div class="t-buttonSet">
    <button
      *ngIf="allowEdit && note.status != 'ACTIVE'"
      [disabled]="saving || !saveEnabled()"
      (click)="saveAndActivate()"
      class="t-button-outline"
    >
      {{ "translate.notes.saveAndActivate" | translate }}
    </button>

    <button
      *ngIf="note.status != null"
      [disabled]="saving || !saveEnabled()"
      (click)="save()"
      class="t-button"
    >
      {{ "translate.notes.save" | translate }}
    </button>
  </div>
</div>

<div class="info">
  <p *ngIf="!isNew">
    {{ "translate.tasks.updatedAt" | translate }}
    &nbsp;
    <span>{{ note.updDate | date : "dd/MM/yy HH:mm" }}</span>
    &nbsp;
    {{ "translate.tasks.updatedBy" | translate }}
    &nbsp;
    <span>{{ note.updUser }}</span>
  </p>
</div>
